import { Content } from 'antd/lib/layout/layout';
import { Typography, List, } from 'antd';
import { Link } from 'react-router-dom';
import MainHeading from '../mainHeading';
import TeamsCard from '../teamsCard';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

interface Props {
    conatctDescLeft: any;
    conatctDescMiddle: any;
    conatctDescRight: any;
}

const Teams = (props: Props) => {
    const { conatctDescLeft, conatctDescMiddle, conatctDescRight } = props;
    useEffect(() => {
        scrollToTop();
    }, []);
    const scrollToTop = () => {
        const top = document.getElementById("top") as HTMLElement;
        top.scrollIntoView();
    };
    return (
        <Content className="our-services teams" id='top'>
            <Helmet>

                <title>{'Contact'}</title>

                <meta name="description" content={'Prime details and contact info for our key personnel. '} />

                <meta property="og:title" content={'Contact'} />

                <meta property="og:description" content={'Prime details and contact info for our key personnel. '} />

            </Helmet>
            <div className="container">
                <MainHeading text="Contact PDD" />
                <div className="contact-addresses-wrapper">
                    <div className="address-container">
                        <div className="address-item">
                            <div className="address-heading">Sales/Digital <br /> Label Management</div>
                            <div className="address">Prime Direct Distribution<br /> Department Sixty Five<br /> 65 Greenwich South Street<br /> London<br /> SE10 8NT</div>
                            <div className="contact">Tel : 0044 (0)20 8320 0988</div>
                        </div>

                        <div className="address-item">
                            <div className="address-heading">Warehouse</div>
                            <div className="address">Prime Direct Distribution<br /> Unit 53 Victoria Industrial Park <br /> Victoria Road<br /> Dartford<br /> Kent<br /> DA1 5AJ</div>
                            <div className="contact">Tel : 0044 (0)1322 294 105</div>
                            {/* Fax : 0044 (0)1322 275 196 */}
                        </div>

                        <div className="address-item">
                            <div className="address-heading">Accounts/Admin</div>
                            <div className="address">Prime Direct Distribution <br />21 Queens Road<br /> Brighton <br />East Sussex<br /> BN1 3XA</div>
                            <div className="contact">Tel : 0044 (0) 1273 949 170</div>
                        </div>
                    </div>
                </div>
                <>
                    <Typography.Text className="sub-title">Key Contacts</Typography.Text>
                </>
                <Typography.Title level={4} className="contact-heading">Director</Typography.Title>
                <div className='listParentCustom'>
                    <List
                        className="teams-listing"
                        dataSource={conatctDescLeft}
                        renderItem={(item: any) =>
                            <List.Item>
                                <TeamsCard image={item.image} title={item.title} category={item.category} mail={item.mail} />
                            </List.Item>
                        }
                    />

                    <List
                        className="teams-listing"
                        dataSource={conatctDescMiddle}
                        renderItem={(item: any) =>
                            <List.Item>
                                <TeamsCard image={item.image} title={item.title} category={item.category} mail={item.mail} />
                            </List.Item>
                        }
                    />
                    <List
                        className="teams-listing"
                        dataSource={conatctDescRight}
                        renderItem={(item: any) =>
                            <List.Item>
                                <TeamsCard image={item.image} title={item.title} category={item.category} mail={item.mail} />
                            </List.Item>
                        }
                    />
                </div>
            </div>
        </Content>
    )
}

export default Teams;